import React from "react";
import styled from "styled-components";

import circle from "assets/images/svg/icon-circle-notch-orenge.svg";
import circle90 from "assets/images/svg/icon-circle-notch90.svg";
import circle180 from "assets/images/svg/icon-circle-notch180.svg";

const NumberImage = ({ number, position }) => {
  const lestImage = {
    0: circle,
    90: circle90,
    180: circle180,
  };

  return (
    <Container>
      {position === 45 ? (
        <img
          loading="lazy"
          src={circle}
          alt="rotate circle"
          style={{ transform: "rotate(45deg)" }}
        />
      ) : (
        <img src={lestImage[position]} alt="icon circle" loading="lazy" />
      )}
      <span>{number}</span>
    </Container>
  );
};

const Container = styled.div`
  span {
    font-family: "Brevia Light Italic";
    line-height: 60px;
    font-size: clamp(28px, 2.5vw, 60px);
    height: 87px;
    align-items: center;
    display: flex;
    padding-left: 20px;
    margin-right: 80px;
  }

  img {
    position: absolute;
    left: 0;
  }

  @media only screen and (max-width: 414px) {
    span {
      margin-right: 60px;
    }
  }
`;

export default NumberImage;
